import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../assets/common/new-era-logo.png';

const DesktopHeader = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="py-6 bg-white text-blue font-bold text-xs">
      <div className="max-w-screen-xl mx-auto flex justify-between items-center px-16">
      <div className="text-2xl font-bold"><Link to="/"><img src={Logo} alt="Logo" className="h-8" /></Link></div>

      <nav className="flex space-x-4 items-center">{[
            { path: '/', label: 'Home' },
            { path: '/about', label: 'About' },
            { path: '/projects', label: 'Projects' },
            { path: '/partnerships', label: 'Partnerships' },
            { path: '/expansion', label: 'Expansion' },
            { path: '/news', label: 'News' },
            { path: '/contact', label: 'Contact Us' },].map((link, index, array) => (
          
          <React.Fragment key={link.path}>
              <Link to={link.path} className={`hover:text-blue hover:underline ${isActive(link.path) ? 'text-blue' : 'text-gray-500'} transition-all duration-[400ms] ease-in-out`}> {link.label}</Link>
              {index < array.length - 1 && (<span className="text-gray-300">|</span>)}
            </React.Fragment>))}
        </nav></div></header>);};

export default DesktopHeader;
